// @ts-nocheck
import { CSRF_TOKEN } from "@pages/csrf";

const useProductBundlesApi = () => {
  const serializeBundle = (data) => {
    const {
      name,
      description,
      details_1,
      details_2,
      details_3,
      monthly_service_fee,
      more_details_url,
      more_details_copy,
      is_hidden,
      product_1,
      product_2,
      is_business,
    } = data;

    return {
      name,
      description,
      details: [details_1, details_2, details_3],
      monthly_service_fee,
      more_details_url,
      more_details_copy,
      is_active: true,
      is_hidden,
      products_ids: [product_1, product_2],
      is_business,
    };
  };

  const create = async (data) => {
    const payload = serializeBundle(data);

    const response = await fetch("/v1/bundles/", {
      method: "POST",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      credentials: "same-origin",
    });

    return response;
  };

  const update = async (data) => {
    const {
      uuid,
      name,
      description,
      details_1,
      details_2,
      details_3,
      monthly_service_fee,
      more_details_url,
      more_details_copy,
      is_hidden,
      product_1,
      product_2,
      changelog,
    } = data;

    const payload = {
      uuid,
      name,
      description,
      details: [details_1, details_2, details_3],
      monthly_service_fee,
      more_details_url,
      more_details_copy,
      is_active: true,
      is_hidden,
      products_ids: [product_1, product_2],
      changelog,
    };

    const response = await fetch(`/v1/bundles/${uuid}/`, {
      method: "PUT",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      credentials: "same-origin",
    });

    return response;
  };

  const deactivate = (bundleUUID: string, changelog?: string) =>
    fetch(`/v1/bundles/${bundleUUID}/deactivate/`, {
      method: "PATCH",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ changelog }),
    });

  const reactivate = (bundleUUID: string, changelog?: string) =>
    fetch(`/v1/bundles/${bundleUUID}/reactivate/`, {
      method: "PATCH",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ changelog }),
    });

  const getAll = () =>
    fetch("/v1/bundles/", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    });

  return {
    update,
    create,
    deactivate,
    reactivate,
    getAll,
    serializeBundle,
  };
};

export default useProductBundlesApi;
